import {
  noImageAvatar,
} from '@touche-lts/panel-ui/dist'
import { makeAutoObservable } from 'mobx'
import { Api } from 'services'
// import { RootStore } from 'mobx-stores/root-store'
import moment from 'moment'
import { CustomerDTO } from 'models/customers'

export class CustomerProfilePageStore {
  private customerApi: Api['customersApi']

  constructor(rootStore: any) {
    this.customerApi = rootStore.generalStore.api.customersApi
    makeAutoObservable(this)
  }

  // OBSERVABLES
  public customer: CustomerDTO = null
  public editMode: boolean = false
  public fullName: string = ''

  // ACTIONS
  private setCustomer = (customer: CustomerDTO): void => {
    this.customer = customer
  }

  public setFullName = (customer: string): void => {
    this.fullName = customer
  }

  // METHODS
  public clearStore = (): void => {
    this.setCustomer(null)
  }

  public loadCustomer = async (): Promise<void> => {
    let customerId = '';

    if (window.location.href.indexOf('/customers/') > -1) {
      const url = window.location.href;
      customerId = url.substring(url.lastIndexOf('/') + 1)
      const customer = await this.customerApi.getCustomerById(customerId)
      if (!customer) return
      this.setCustomer(customer)
    }
  }

  public setCustomerProps = (props: Partial<CustomerDTO>): void => {
    this.setCustomer({ ...this.customer, ...props })
  }

  // COMPUTED
  public get customerFullName(): string {
    if (!this.customer) return ''

    const { fullName } = this.customer.user
    return `${fullName}`.trim()
  }

  public get userImageUrl() {
    if (!this.customer) return noImageAvatar
    const { imageUrl } = this.customer.user
    return imageUrl || noImageAvatar
  }

  public get customerAddedOn(): string {
    if (!this.customer) return ''
    const { registeredDate } = this.customer.user

    return moment(registeredDate).format('DD.MM.YYYY')
  }
}
